import type { EngineEvent } from '../types.js';

export class EventQueue {
  private events: EngineEvent[] = [];

  push(ev: EngineEvent): void {
    this.events.push(ev);
  }

  drain(): EngineEvent[] {
    const out = this.events;
    this.events = [];
    return out;
  }

  peek(): ReadonlyArray<EngineEvent> {
    return this.events;
  }

  clear(): void {
    this.events.length = 0;
  }
}
